import React, { memo } from 'react';
import { useSecondTick } from '../../hooks/useSecondTick';

type Props = {
  lastUpdate: number;
  isFa: boolean;
};

/** “Data updated N min ago” — 1s tick, does not re-render charts. */
export const BannerDataFreshnessLine = memo(function BannerDataFreshnessLine({ lastUpdate, isFa }: Props) {
  const now = useSecondTick();
  const bannerMinsAgo = Math.max(0, Math.floor((now - lastUpdate) / 60_000));

  return (
    <p className="font-mono text-[10px] text-ir-muted pt-1">
      {isFa ? `به‌روزرسانی داده: ${bannerMinsAgo} دقیقه پیش` : `Data updated ${bannerMinsAgo} min ago`}
    </p>
  );
});
